const getPathFromUrl = (url: string) => url.split('?')[0];

export default getPathFromUrl;
